var map = {
	"./phoneSideBar/authority-active.png": "52e2",
	"./phoneSideBar/dealer-active.png": "d95e",
	"./phoneSideBar/device-active.png": "afc5",
	"./phoneSideBar/distribution-active.png": "833a",
	"./phoneSideBar/help-active.png": "06ef",
	"./phoneSideBar/home-active.png": "8f4f",
	"./phoneSideBar/log-active.png": "c432",
	"./phoneSideBar/setting-active.png": "c1ac",
	"./phoneSideBar/storage-active.png": "12d6",
	"./phoneSideBar/user-active.png": "762d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8953";